/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bell-notice': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M916.882 789.186l-65.245-147.888V430.34c0-139.188-89.167-265.328-217.482-315.35C629.805 54.097 577.61 6.25 514.54 6.25S401.449 54.096 394.924 114.99c-130.49 50.022-217.482 176.162-217.482 315.35v210.958l-65.245 147.888c-8.7 19.574-6.524 41.322 4.35 58.72 10.874 17.4 30.447 28.273 52.196 28.273h691.594c21.748 0 41.321-10.874 52.196-28.272s13.048-41.322 4.35-58.72zm-743.79 21.749l69.595-156.588V430.34c0-119.615 80.468-226.181 195.734-260.979l26.098-8.699-4.35-28.273v-6.524c0-30.448 23.923-54.37 54.37-54.37s54.371 23.922 54.371 54.37v8.7l-4.35 28.272 26.099 8.7C705.924 206.332 786.393 312.9 786.393 432.514v224.007l69.594 156.587H173.092zm341.448 206.608c60.895 0 108.74-47.846 108.74-108.741H405.799c0 60.895 47.847 108.74 108.742 108.74z" _fill="#fff"/>'
  }
})
